import script from "./FormItemsGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./FormItemsGroup.vue?vue&type=script&setup=true&lang=js"

import "./FormItemsGroup.vue?vue&type=style&index=0&id=1ffc76f5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ffc76f5"]])

export default __exports__